import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { http, apiError } from "@/lib/api";
import { BRAND } from "@/lib/brand";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await http.post("/auth/login", { email, password });
      toast.success(`Welcome back, ${data.user?.name || "Admin"}!`);
      nav("/admin");
    } catch (err) {
      toast.error(apiError(err, "Invalid email or password."));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="grid min-h-screen place-items-center bg-[#F4F3F6] px-6" style={{ fontFamily: "Outfit, sans-serif" }}>
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-sm rounded-2xl border border-black/5 bg-white p-8 shadow-sm"
      >
        <img src={BRAND.logo} alt="logo" className="mx-auto h-14 w-14 rounded-full object-cover" />
        <h1 className="mt-4 text-center text-2xl font-bold text-[#4A235A]">Admin Dashboard</h1>
        <p className="mt-1 text-center text-sm text-gray-500">Drawn Into Legend</p>
        <div className="mt-6 space-y-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            data-testid="admin-email"
            className="w-full rounded-xl border border-gray-200 p-3 text-sm outline-none focus:border-[#9B5DE5]"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            data-testid="admin-password"
            className="w-full rounded-xl border border-gray-200 p-3 text-sm outline-none focus:border-[#9B5DE5]"
          />
        </div>
        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="mt-6 inline-flex min-h-[48px] w-full items-center justify-center gap-2 rounded-xl bg-[#4A235A] font-bold text-white transition-transform hover:-translate-y-0.5 disabled:opacity-60"
        >
          {busy ? <Loader2 className="animate-spin" size={18} /> : <Lock size={18} />} Sign in
        </button>
      </form>
    </div>
  );
}
